import { BaseAPI, ReqOptions } from "@xy-planning-network/trees"

const LoginAPI = {
  createMagicLogin(email: string, next: string, opts?: ReqOptions) {
    return BaseAPI.post<Record<string, never>>(
      `/login?next=${next}`,
      { email: email },
      opts || {}
    )
  },
}

export default LoginAPI
